import * as React from 'react';
import { useState, useEffect } from "react";
import Modal from "../../../component/Global/Modal";
import { useDOMAttachToSystemStore } from 'src/hooks/domAttachToSystem';

const AddShippingAddressPopup = (props) => {
    const [status, SetStatus] = useState(false);
    const [{ AddShippingAddressPopup }, {}, {}] = useDOMAttachToSystemStore();
    useEffect(() => {
        if (AddShippingAddressPopup) {
            SetStatus(true)
        }
    }, [AddShippingAddressPopup]);
    const onHide = (action = true) => {
        SetStatus(false)
    };
    return (
        <>
            <Modal show={status} onHide={() => {
                onHide()
            }}>
                <div className="avnet-modal">
                    <div className="avnet-modal-inner">
                        <button type="button" className="close py-3" data-dismiss="modal"
                            onClick={() => {
                                onHide()
                            }}>×
                        </button>
                        <div className="modal-header justify-content-center mt-0">
                            <h3 className="pcn-modal-heading m-auto" id="exampleModalLabel">Add Shipping Address</h3>
                        </div>
                        <div className="modal-body pt-0 text-center">
                            <p>In order to add a new address.<br />Please contact your account representative.</p>
                        </div>
                        <div className="modal-footer text-center">
                            <button type="button" className="bs5 btn btn-primary m-auto w145" data-dismiss="modal"
                                onClick={() => {
                                    onHide()
                                }}>Close</button>
                        </div>
                    </div>
                </div>
            </Modal>
        </>
    );
}

export default AddShippingAddressPopup;